import React, { useState } from "react";
import { FiChevronDown, FiSmartphone, FiTablet, FiWatch } from "react-icons/fi";
import BrandGrid from "../BrandGrid";
import { Link } from "react-router-dom";
import { CATEGORY_ROUTE } from "../../../routes/constant";

const DesktopNav = ({ isDarkMode, categories }) => {
  const [activeCategory, setActiveCategory] = useState(null);

  if (!categories) return null;

  return (
    <div className={`flex items-center justify-start gap-1 py-2 px-2 ${
      isDarkMode ? 'bg-gray-900' : 'bg-white'
    }`}>
      {categories.map((category) => {
        const categoryBrands = category.brands || [];
        const isActive = activeCategory === category.id;

        return (
          <div
            key={category.id}
            className="relative"
            onMouseEnter={() => setActiveCategory(category.id)}
            onMouseLeave={() => setActiveCategory(null)}
          >
            {/* Category Link */}
            <Link
              to={CATEGORY_ROUTE(category.slug)}
              className={`
                flex items-center gap-1.5 px-2.5 py-1.5 rounded-md transition-all text-xs
                ${isDarkMode 
                  ? 'text-gray-200 hover:text-white hover:bg-gray-800' 
                  : 'text-gray-700 hover:text-gray-900 hover:bg-gray-100'
                }
                ${isActive && isDarkMode ? 'bg-gray-800 text-white' : ''}
                ${isActive && !isDarkMode ? 'bg-gray-100 text-gray-900' : ''}
              `}
            >
              {/* Category Icon */}
              <span className={isDarkMode ? 'text-gray-400' : 'text-gray-500'}>
                {category.image ? (
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-3.5 h-3.5 object-contain"
                    style={{ filter: isDarkMode ? 'brightness(0.9)' : 'none' }}
                  />
                ) : (
                  <>
                    {category.name?.includes("Phone") && (
                      <FiSmartphone size={12} />
                    )}
                    {category.name?.includes("Tablet") && <FiTablet size={12} />}
                    {category.name?.includes("Watch") && <FiWatch size={12} />}
                  </>
                )}
              </span>
              
              {/* Category Name */}
              <span className="font-medium">
                {category.display_name || category.name}
              </span>
              
              {/* Dropdown Arrow */}
              {categoryBrands.length > 0 && (
                <FiChevronDown
                  size={10}
                  className={`
                    transition-transform duration-200
                    ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}
                    ${isActive ? "rotate-180" : ""}
                  `}
                />
              )}
            </Link>

            {/* Arrow Indicator */}
            {isActive && categoryBrands.length > 0 && (
              <div className="absolute left-1/2 -translate-x-1/2 -bottom-[15px] z-50">
                <div
                  className={`
                    w-3 h-3 rotate-45
                    ${isDarkMode 
                      ? 'bg-gray-800 border-gray-700' 
                      : 'bg-white border-gray-200'
                    }
                    border-l border-t
                  `}
                />
              </div>
            )}

            {/* Dropdown Menu */}
            {categoryBrands.length > 0 && isActive && (
              <div
                className="absolute left-0 top-full pt-2 z-[55]"
                style={{ minWidth: "240px" }}
              >
                <div
                  className={`
                    rounded-xl shadow-2xl overflow-hidden
                    ${isDarkMode 
                      ? 'bg-gray-800 border border-gray-700' 
                      : 'bg-white border border-gray-200'
                    }
                  `}
                >
                  <BrandGrid
                    brands={categoryBrands}
                    categorySlug={category.slug}
                    isDarkMode={isDarkMode}
                    onClose={() => setActiveCategory(null)}
                  />
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default DesktopNav;